export class Utils {
  static stringToCamelCase(str: string) {
    return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (_match, chr) => {
      return chr.toUpperCase();
    });
  }
}

/*
  DOM elements search helper
 */
export class Search {
  static byId<T>(id: string): T {
    return !id.includes("#")
      ? (document.getElementById(id) as T)
      : (document.getElementById(`#${id}`) as T);
  }

  static getElementByDataAttrValue(
    container: HTMLElement | Document = document,
    dataAttrName: string,
    value: string
  ) {
    const all = Array.from(
      container.querySelectorAll(`[data-${dataAttrName}]`)
    ) as HTMLElement[];

    return all?.find(
      (el: HTMLElement) =>
        el.dataset[Utils.stringToCamelCase(dataAttrName)] === value
    );
  }
}

export const getCurrencySymbol = (): string => {
  return (window as any).__APP__?.currency?.symbol ?? '';
};

export const formatMoney = (value: number): string => {
  const rubles = Math.floor(value / 100);
  const cents = Math.floor(value % 100);
  const symbol = getCurrencySymbol();

  return `${rubles.toLocaleString('ru-RU')}${cents > 0 ? '.' + cents.toString().padStart(2, '0') : ''} ${symbol}`;
}

export const plural = (number: number, singleValue: string, pluralValueFirst: string, pluralValueSecond: string): string => {
  if (1 === number % 10 && 11 !== number % 100) {
    return singleValue;
  }

  if (number % 10 >= 2 && number % 10 <= 4 && ![12, 13, 14].includes(number % 100)) {
    return pluralValueFirst;
  }

  return pluralValueSecond;
}
